// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index';
import wx from 'weixin-js-sdk'//微信分享sdk
import 'lib-flexible/flexible'
import { wechatShare,wechatScanQRCode,wechatGetLocation } from './common/wxConfig'
import 'babel-polyfill'
import Http from './common/request';
import * as echarts from 'echarts/lib/echarts.js';
import { BarChart, PieChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import { Lazyload } from 'vant';

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent
]);

Vue.use(Lazyload);
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
window.$http = Http;
Vue.prototype.wechatShare  = wechatShare
Vue.prototype.wechatScanQRCode  = wechatScanQRCode
Vue.prototype.wechatGetLocation  = wechatGetLocation
Vue.prototype.wx  = wx

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js